export default __webpack_public_path__ + "static/media/Multifle_Study.a98efd31.png";